import React, {Component, Fragment} from 'react';
import {Route, Routes} from "react-router-dom";
import RoutePaths from '../../utils/RoutePaths';
import RuleSet from "./RuleSet";

// Helper to get relative path from full path
const getRelativePath = (fullPath) => fullPath.replace(/^\/admin\/ruleset\/?/, '') || '/';

class VendorRuleset extends Component {
    render() {
        return (
            <Fragment>
                <Routes>
                    <Route path={getRelativePath(RoutePaths.defaultVendorRuleset)} element={<RuleSet />} />
                </Routes>
            </Fragment>
        );
    }
}

export default VendorRuleset;